import { copy } from '@ohear/shared'
import { Card, Spinner } from '@ohear/ui'
import { createFileRoute } from '@tanstack/react-router'
import { AccountTabs } from '../../features/account/AccountTabs'
import { DeviceTestResults } from '../../features/account/DeviceTestResults'
import { HeadphoneTest } from '../../features/account/HeadphoneTest'
import { MicTest } from '../../features/account/MicTest'
import { NetworkTest } from '../../features/account/NetworkTest'
import { useAccountProfile } from '../../lib/api/account'
import { useT } from '../../lib/i18n/use-t'
import { AccountHeader } from './profile'

export const Route = createFileRoute('/account/devices')({
  component: DevicesPage,
})

function DevicesPage() {
  const t = useT()
  const profile = useAccountProfile()
  const isActor = profile.data?.primary_role === 'actor'

  if (profile.isLoading) {
    return (
      <Section>
        <div className="flex items-center gap-2 text-[var(--text-2)]">
          <Spinner /> Loading...
        </div>
      </Section>
    )
  }
  if (!profile.data) {
    return (
      <Section>
        <Card>
          <p className="m-0">{t(copy.common.SIGN_IN_REQUIRED.devices)}</p>
        </Card>
      </Section>
    )
  }

  return (
    <Section profile={profile.data}>
      <AccountTabs active="devices" isActor={Boolean(isActor)}>
        <div className="flex flex-col gap-4">
          <p className="text-[13px] text-[var(--text-2)] m-0">
            Run these checks before your first session, or any time you change rooms / hardware.
          </p>
          <DeviceTestResults
            results={profile.data.last_device_test_results ?? null}
            lastTestedAt={profile.data.last_device_test_at ?? null}
          />
          <MicTest />
          <HeadphoneTest />
          <NetworkTest />
        </div>
      </AccountTabs>
    </Section>
  )
}

function Section({
  children,
  profile,
}: {
  children: React.ReactNode
  profile?: import('../../lib/api/account').AccountProfile
}) {
  return (
    <section className="flex flex-col gap-4">
      <AccountHeader profile={profile} />
      {children}
    </section>
  )
}
